// extracted by mini-css-extract-plugin
export var chip = "_bn-0";
export var filterDropdown = "_bn-5";
export var filterItem = "_bn-6";
export var icon = "_bn-1";
export var removeButton = "_bn-3";
export var removeIcon = "_bn-4";
export var separator = "_bn-2";